module.exports = __webpack_public_path__ + "img/education.df6cbb56.svg";